type PosterCardProps = {
  title: string;
  cover: string;
  rating?: number;
  genre?: string;
  region?: string;
  type?: string;
  episodes?: number;
  badge?: string;
  compact?: boolean;
  alt?: string;
};

export default function PosterCard({
  title,
  cover,
  rating,
  genre,
  region,
  type,
  episodes,
  badge,
  compact = false,
  alt,
}: PosterCardProps) {
  return (
    <article className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-300">
      <div className={`relative w-full ${compact ? "h-56" : "h-64 md:h-72"} overflow-hidden bg-background-200`}>
        <img
          src={cover}
          alt={alt || `${title} 封面`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent"></div>
        {badge && (
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium">
            {badge}
          </span>
        )}
        {typeof rating === "number" && (
          <span className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full bg-foreground-950/70 text-accent-300 text-xs font-medium backdrop-blur">
            <i className="ri-star-fill" aria-hidden="true"></i>
            {rating.toFixed(1)}
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="font-heading font-bold text-background-50 text-sm md:text-base truncate">
            {title}
          </h3>
          <div className="mt-1 flex items-center flex-wrap gap-x-2 gap-y-1 text-xs text-background-200/90">
            {region && <span>{region}</span>}
            {type && (
              <>
                <span className="text-background-300/50">·</span>
                <span>{type}</span>
              </>
            )}
            {typeof episodes === "number" && (
              <>
                <span className="text-background-300/50">·</span>
                <span>{episodes} 话</span>
              </>
            )}
          </div>
        </div>
      </div>
      {genre && (
        <div className="px-3 py-2.5 flex items-center justify-between gap-2">
          <span className="text-xs text-foreground-600 truncate">{genre}</span>
          <span className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </span>
        </div>
      )}
    </article>
  );
}